/** Client-side alignment with hardened SMS API validation */

export const SMS_PHONE_SEGMENT_MIN = 9;
export const SMS_PHONE_SEGMENT_MAX = 25;
export const SMS_MESSAGE_SHORT_MAX = 160;
export const SMS_MESSAGE_FILTERED_MAX = 612;
export const SMS_MAX_COMMA_RECIPIENTS = 2000;

/** Allowed chars per segment: digits, +, spaces, hyphens */
const PHONE_SEGMENT_RE = /^[\d+\s-]+$/;

/** Strip characters that can never be valid in the recipients line (commas preserved). */
export function sanitizeSmsRecipientsInput(raw) {
	return String(raw || "").replace(/[^\d,+\s-]/g, "");
}

/**
 * @param {string} segment — trimmed single phone value
 * @returns {boolean}
 */
export function isValidSmsPhoneSegment(segment) {
	const s = String(segment || "").trim();
	if (
		s.length < SMS_PHONE_SEGMENT_MIN ||
		s.length > SMS_PHONE_SEGMENT_MAX
	) {
		return false;
	}
	return PHONE_SEGMENT_RE.test(s);
}

/**
 * @param {string} raw
 * @returns {string[]}
 */
export function splitRecipientSegments(raw) {
	return String(raw || "")
		.split(",")
		.map((x) => x.trim())
		.filter((x) => x.length > 0);
}

/**
 * @param {string} msg
 * @returns {boolean} true if at least one non-whitespace character
 */
export function messageHasNonWhitespace(msg) {
	return /\S/.test(String(msg || ""));
}

/**
 * @param {string} raw
 * @returns {string} trimmed; empty segments removed; commas normalized
 */
export function normalizeCommaRecipientsString(raw) {
	return splitRecipientSegments(raw).join(", ");
}

/**
 * Canonical customer-type values for filtered SMS (backend uppercases).
 */
export const SMS_CUSTOMER_TYPE_VALUES = [
	"INDIVIDUAL",
	"GROUP",
	"CORPORATE",
	"IN_TRUST",
];
